module.exports = __webpack_public_path__ + "img/home_mashangjijian.cf5f3a8.png";